// @ts-check
import { Image } from '@codex/basics';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DesktopImage = styled(Image)`
  display: none;

  @media ${({ theme }) => `${theme.breakpoints.desktop}`} {
    & {
      display: block;
    }
  }
`;

const HandHeldImage = styled(Image)`
  @media ${({ theme }) => `${theme.breakpoints.desktop}`} {
    & {
      display: none;
    }
  }
`;

export const HeaderLogo = props => (
  <>
    <DesktopImage
      title={props.logoAlt}
      link={props.logoLink}
      image={props.desktopLogoSrc}
      width={props.desktopLogoWidth}
      height={props.desktopLogoHeight}
    />
    <HandHeldImage
      title={props.logoAlt}
      link={props.logoLink}
      image={props.handHeldLogoSrc}
      width={props.handHeldLogoWidth}
      height={props.handHeldLogoHeight}
    />
  </>
);

HeaderLogo.propTypes = {
  desktopLogoSrc: PropTypes.string.isRequired,
  desktopLogoWidth: PropTypes.number,
  desktopLogoHeight: PropTypes.number,
  handHeldLogoSrc: PropTypes.string.isRequired,
  handHeldLogoWidth: PropTypes.number,
  handHeldLogoHeight: PropTypes.number,
  logoAlt: PropTypes.string.isRequired,
  logoLink: PropTypes.string.isRequired,
  qa: PropTypes.string
};

HeaderLogo.defaultProps = {
  desktopLogoWidth: 204,
  desktopLogoHeight: 60,
  handHeldLogoWidth: 180,
  handHeldLogoHeight: 32,
  qa: undefined
};

/** @component */
export default styled(HeaderLogo)``;
